/**
 * Leaderboard state (Task 3). Pure data only.
 * We store just an epoch timestamp; every NPC's live net worth is derived
 * deterministically from (now - epoch) via the config growth curve. The
 * player's own total assets are computed live from cash + holdings value.
 */

export interface LeaderboardState {
  /** ladder epoch (ms). NPC growth is measured from here. Set on first play. */
  epoch: number;
  /** best rank the player has ever reached (1 = top). 0 = never ranked yet. */
  bestRank: number;
}

export function createInitialLeaderboardState(): LeaderboardState {
  return { epoch: Date.now(), bestRank: 0 };
}

/** Fills missing/invalid fields on load (backward-compatible saves). */
export function migrateLeaderboardState(saved: unknown): LeaderboardState {
  const base = createInitialLeaderboardState();
  if (!saved || typeof saved !== 'object') return base;
  const s = saved as Partial<LeaderboardState>;
  return {
    epoch: typeof s.epoch === 'number' && s.epoch > 0 ? s.epoch : base.epoch,
    bestRank: typeof s.bestRank === 'number' && s.bestRank >= 0 ? s.bestRank : 0,
  };
}
